// extracted by mini-css-extract-plugin
export default {"container":"Messages_container__nLZ9V","buttonContainer":"Messages_buttonContainer__fzFLB"};